// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Paper = require("@mui/material/Paper").default;
var Radio = require("@mui/material/Radio").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var RadioGroup = require("@mui/material/RadioGroup").default;
var Logout = require("@mui/icons-material/Logout").default;
var MM_wrk_editor_substitution = require("../worker/MM_wrk_editor_substitution.bs.js");
var SwapVert = require("@mui/icons-material/SwapVert").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function makeInitialState(expr1Init, expr2Init) {
  return {
          expr1Str: Belt_Option.getWithDefault(expr1Init, ""),
          expr1Err: undefined,
          expr2Str: Belt_Option.getWithDefault(expr2Init, ""),
          expr2Err: undefined,
          results: undefined,
          checkedResultIdx: undefined,
          invalidResults: undefined
        };
}

function setResults(st, results) {
  var validResults;
  validResults = results.TAG === /* Ok */0 ? ({
        TAG: /* Ok */0,
        _0: results._0.filter(function (res) {
              return Belt_Option.isNone(res.err);
            })
      }) : ({
        TAG: /* Error */1,
        _0: results._0
      });
  var invalidResults;
  invalidResults = results.TAG === /* Ok */0 ? results._0.filter(function (res) {
          return Belt_Option.isSome(res.err);
        }) : [];
  var checkedResultIdx;
  checkedResultIdx = validResults.TAG === /* Ok */0 && validResults._0.length === 1 ? 0 : undefined;
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: validResults,
          checkedResultIdx: checkedResultIdx,
          invalidResults: invalidResults
        };
}

function clearResults(st) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: undefined,
          checkedResultIdx: undefined,
          invalidResults: undefined
        };
}

function setExpr1Str(st, str) {
  return {
          expr1Str: str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function setExpr2Str(st, str) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function swapExprs(st) {
  return {
          expr1Str: st.expr2Str,
          expr1Err: undefined,
          expr2Str: st.expr1Str,
          expr2Err: undefined,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function copyExpr1ToExpr2(st) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: undefined,
          expr2Str: st.expr1Str,
          expr2Err: undefined,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function copyExpr2ToExpr1(st) {
  return {
          expr1Str: st.expr2Str,
          expr1Err: undefined,
          expr2Str: st.expr2Str,
          expr2Err: undefined,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function toggleResultChecked(st, idx) {
  if (Caml_obj.equal(st.checkedResultIdx, idx)) {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: undefined,
            invalidResults: st.invalidResults
          };
  } else {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: idx,
            invalidResults: st.invalidResults
          };
  }
}

function rndIconButton(icon, onClick, active, title, param) {
  return React.createElement("span", {
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

var findSubsByMatch = "match";

var findSubsByUnif = "unif";

function MM_cmp_substitution(props) {
  var onSubstitutionSelected = props.onSubstitutionSelected;
  var onCanceled = props.onCanceled;
  var wrkCtx = props.wrkCtx;
  var expr2Init = props.expr2Init;
  var expr1Init = props.expr1Init;
  var editorState = props.editorState;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return makeInitialState(expr1Init, expr2Init);
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageStr("find-substitution-by", findSubsByMatch);
  var setFindSubsBy = match$1[1];
  var findSubsBy = match$1[0];
  var expr1TextFieldRef = React.useRef(null);
  var expr2TextFieldRef = React.useRef(null);
  var methodName = findSubsBy === findSubsByMatch ? "Match" : "Unify";
  var actDetermineSubs = function (param) {
    var findIncorrectSymbol = function (syms) {
      return Caml_option.undefined_to_opt(syms.find(function (sym) {
                      return !(MM_context.isConst(wrkCtx, sym) || MM_context.isVar(wrkCtx, sym));
                    }));
    };
    var syms1 = Common.getSpaceSeparatedValuesAsArray(state.expr1Str);
    var incorrectSymbol1 = findIncorrectSymbol(syms1);
    var syms2 = Common.getSpaceSeparatedValuesAsArray(state.expr2Str);
    var incorrectSymbol2 = findIncorrectSymbol(syms2);
    Curry._1(setState, (function (st) {
            var st$1 = incorrectSymbol1 !== undefined ? ({
                  expr1Str: st.expr1Str,
                  expr1Err: "Unknown symbol - '" + incorrectSymbol1 + "'",
                  expr2Str: st.expr2Str,
                  expr2Err: st.expr2Err,
                  results: st.results,
                  checkedResultIdx: st.checkedResultIdx,
                  invalidResults: st.invalidResults
                }) : ({
                  expr1Str: st.expr1Str,
                  expr1Err: undefined,
                  expr2Str: st.expr2Str,
                  expr2Err: st.expr2Err,
                  results: st.results,
                  checkedResultIdx: st.checkedResultIdx,
                  invalidResults: st.invalidResults
                });
            if (incorrectSymbol2 !== undefined) {
              return {
                      expr1Str: st$1.expr1Str,
                      expr1Err: st$1.expr1Err,
                      expr2Str: st$1.expr2Str,
                      expr2Err: "Unknown symbol - '" + incorrectSymbol2 + "'",
                      results: st$1.results,
                      checkedResultIdx: st$1.checkedResultIdx,
                      invalidResults: st$1.invalidResults
                    };
            } else {
              return {
                      expr1Str: st$1.expr1Str,
                      expr1Err: st$1.expr1Err,
                      expr2Str: st$1.expr2Str,
                      expr2Err: undefined,
                      results: st$1.results,
                      checkedResultIdx: st$1.checkedResultIdx,
                      invalidResults: st$1.invalidResults
                    };
            }
          }));
    if (!(Belt_Option.isNone(incorrectSymbol1) && Belt_Option.isNone(incorrectSymbol2) && syms1.length > 0 && syms2.length > 0)) {
      return Curry._1(setState, clearResults);
    }
    var results = MM_wrk_editor_substitution.findPossibleSubs(editorState, MM_context.ctxSymsToIntsExn(wrkCtx, syms1), MM_context.ctxSymsToIntsExn(wrkCtx, syms2), findSubsBy === findSubsByMatch);
    Curry._1(setState, (function (__x) {
            return setResults(__x, results);
          }));
  };
  var actFocus = function (ref) {
    var domElem = ref.current;
    if (domElem == null) {
      return ;
    }
    var match = domElem.focus;
    if (match !== undefined) {
      return domElem.focus();
    }
    
  };
  var actExpr1OnEnter = function (param) {
    if (state.expr2Str.trim() === "") {
      return actFocus(expr2TextFieldRef);
    } else {
      return actDetermineSubs(undefined);
    }
  };
  var actExpr2OnEnter = function (param) {
    if (state.expr1Str.trim() === "") {
      return actFocus(expr1TextFieldRef);
    } else {
      return actDetermineSubs(undefined);
    }
  };
  var actExpr1Change = function (str) {
    Curry._1(setState, clearResults);
    Curry._1(setState, (function (__x) {
            return setExpr1Str(__x, str);
          }));
  };
  var actExpr2Change = function (str) {
    Curry._1(setState, clearResults);
    Curry._1(setState, (function (__x) {
            return setExpr2Str(__x, str);
          }));
  };
  var actFindSubsByChange = function (newValue) {
    Curry._1(setState, clearResults);
    Curry._1(setFindSubsBy, (function (param) {
            if (newValue === findSubsByMatch) {
              return findSubsByMatch;
            } else {
              return findSubsByUnif;
            }
          }));
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndExpr = function (label, value, autoFocus, onChange, tabIndex, onEnter, ref) {
    var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCanceled, undefined);
    var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, onEnter, undefined);
    return React.createElement(TextField, {
                inputRef: Caml_option.some(ref),
                value: value,
                label: label,
                size: "small",
                style: {
                  width: "700px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(onChange, param);
                  }),
                onKeyDown: (function (param) {
                    return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                  }),
                inputProps: {
                  tabIndex: tabIndex
                },
                autoFocus: autoFocus
              });
  };
  var expr1Label = "" + methodName + " what";
  var expr2Label = "" + methodName + " with";
  var rndInput = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    children: Caml_option.some(null)
                  }, "Find substitution by:", React.createElement(RadioGroup, {
                        value: findSubsBy,
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actFindSubsByChange, param);
                          }),
                        row: true,
                        children: Caml_option.some(null)
                      }, React.createElement(FormControlLabel, {
                            control: React.createElement(Radio, {}),
                            label: "Matching",
                            value: findSubsByMatch
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Radio, {}),
                            label: "Unification",
                            value: findSubsByUnif
                          }))), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndExpr(expr1Label, state.expr1Str, true, actExpr1Change, 1, actExpr1OnEnter, expr1TextFieldRef)), React.createElement("td", undefined, rndIconButton(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(90deg)"
                                        }
                                      }), (function (param) {
                                      Curry._1(setState, clearResults);
                                      Curry._1(setState, copyExpr1ToExpr2);
                                    }), true, "Copy this statement to the below text field", undefined)), React.createElement("td", undefined, rndIconButton(React.createElement(SwapVert, {}), (function (param) {
                                      Curry._1(setState, clearResults);
                                      Curry._1(setState, swapExprs);
                                    }), true, "Swap \"" + expr1Label + "\" and \"" + expr2Label + "\"", undefined))))), rndError(state.expr1Err), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndExpr(expr2Label, state.expr2Str, false, actExpr2Change, 2, actExpr2OnEnter, expr2TextFieldRef)), React.createElement("td", undefined, rndIconButton(React.createElement(Logout, {
                                        style: {
                                          transform: "rotate(-90deg)"
                                        }
                                      }), (function (param) {
                                      Curry._1(setState, clearResults);
                                      Curry._1(setState, copyExpr2ToExpr1);
                                    }), true, "Copy this statement to the above text field", undefined))))), rndError(state.expr2Err), React.createElement(Expln_React_Row.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            actDetermineSubs(undefined);
                          }),
                        variant: "contained",
                        color: "grey",
                        children: "Find substitution"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCanceled, undefined);
                          }),
                        children: "Cancel"
                      })));
  };
  var rndResultButtons = function (param) {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    if (results.TAG !== /* Ok */0) {
      return null;
    }
    var numOfResults = results._0.length;
    if (numOfResults > 0) {
      return React.createElement(Expln_React_Row.make, {
                  children: Caml_option.some(null)
                }, React.createElement(Button, {
                      onClick: (function (param) {
                          var results = state.results;
                          if (results === undefined) {
                            return ;
                          }
                          if (results.TAG !== /* Ok */0) {
                            return ;
                          }
                          var results$1 = results._0;
                          var idx = state.checkedResultIdx;
                          if (idx !== undefined && 0 <= idx && idx < results$1.length) {
                            return Curry._1(onSubstitutionSelected, Caml_array.get(results$1, idx));
                          }
                          
                        }),
                      variant: "contained",
                      disabled: Belt_Option.isNone(state.checkedResultIdx),
                      children: Caml_option.some(numOfResults === 1 ? "Apply" : "Apply selected")
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(onCanceled, undefined);
                        }),
                      children: "Cancel"
                    }));
    } else {
      return null;
    }
  };
  var rndNewDisj = function (wrkSubs) {
    if (MM_context.disjIsEmpty(wrkSubs.newDisj)) {
      return null;
    }
    var tableRows = [];
    MM_context.disjForEachArr(wrkSubs.newDisj, (function (disjGrp) {
            var disjGrpStr = "$d " + MM_context.ctxIntsToStrExn(wrkCtx, disjGrp) + " $.";
            tableRows.push(React.createElement("tr", {
                      key: disjGrpStr
                    }, React.createElement("td", undefined, disjGrpStr)));
          }));
    return React.createElement("table", undefined, React.createElement("tbody", undefined, tableRows));
  };
  var rndSubs = function (wrkSubs) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_MapInt.toArray(wrkSubs.subs).map(function (param) {
                        var expr = param[1];
                        var v = param[0];
                        if (expr.length === 1 && v === Caml_array.get(expr, 0)) {
                          return null;
                        } else {
                          return React.createElement("tr", {
                                      key: String(v)
                                    }, React.createElement("td", undefined, MM_context.ctxIntToSymExn(wrkCtx, v)), React.createElement("td", undefined, "\u2192"), React.createElement("td", undefined, MM_context.ctxIntsToStrExn(wrkCtx, expr)));
                        }
                      })));
  };
  var rndSubsErr = function (err) {
    if (err === undefined) {
      return null;
    }
    var errDescr;
    errDescr = err.TAG === /* CommonVar */0 ? "substitutions for disjoint variables " + MM_context.ctxIntToSymExn(wrkCtx, err.var1) + " and " + MM_context.ctxIntToSymExn(wrkCtx, err.var2) + " " + ("have a common variable " + MM_context.ctxIntToSymExn(wrkCtx, err.commonVar) + "") : "could not prove [" + MM_context.ctxIntsToStrExn(wrkCtx, err.typeExpr) + "] for " + MM_context.ctxIntToSymExn(wrkCtx, err.var) + " " + String.fromCharCode(8594) + (" [" + MM_context.ctxIntsToStrExn(wrkCtx, err.subsExpr) + "]");
    return React.createElement("div", undefined, React.createElement("span", {
                    style: {
                      color: "red"
                    }
                  }, "Error: "), errDescr);
  };
  var rndWrkSubs = function (wrkSubs) {
    return React.createElement(React.Fragment, undefined, rndNewDisj(wrkSubs), rndSubs(wrkSubs), rndSubsErr(wrkSubs.err));
  };
  var getNumberOfResults = function (arrOpt) {
    return Belt_Option.getWithDefault(Belt_Option.map(arrOpt, (function (arr) {
                      return arr.length;
                    })), 0);
  };
  var rndResults = function (param) {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    if (results.TAG !== /* Ok */0) {
      return "Error: " + results._0 + "";
    }
    var results$1 = results._0;
    var numOfInvalidResults = getNumberOfResults(state.invalidResults);
    var summary = React.createElement(React.Fragment, undefined, "Found substitutions: " + ("" + String(results$1.length) + " valid, "), numOfInvalidResults === 0 ? "0 invalid." : React.createElement("span", {
                style: {
                  color: "blue",
                  cursor: "pointer"
                },
                onClick: (function (param) {
                    var invalidResults = state.invalidResults;
                    if (invalidResults !== undefined) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(Expln_React_Column.make, {
                                                  spacing: 1,
                                                  style: {
                                                    margin: "10px"
                                                  },
                                                  children: Caml_option.some(null)
                                                }, React.createElement("span", {
                                                      style: {
                                                        fontWeight: "bold"
                                                      }
                                                    }, "Invalid substitutions:"), invalidResults.map(function (res, i) {
                                                      return JsxPPXReactSupport.createElementWithKey(String(i), Paper, {
                                                                  children: Caml_option.some(React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndWrkSubs(res))))))
                                                                });
                                                    }), React.createElement(Button, {
                                                      onClick: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        }),
                                                      variant: "contained",
                                                      children: "Close"
                                                    }));
                                    }));
                            }));
                      return ;
                    }
                    
                  })
              }, String(numOfInvalidResults) + " invalid."));
    var numOfResults = results$1.length;
    return React.createElement(Expln_React_Column.make, {
                children: Caml_option.some(null)
              }, summary, results$1.map(function (res, i) {
                    return JsxPPXReactSupport.createElementWithKey(String(i), Paper, {
                                children: Caml_option.some(React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, numOfResults > 1 ? React.createElement("td", undefined, React.createElement(Checkbox, {
                                                            checked: Caml_obj.equal(state.checkedResultIdx, i),
                                                            onChange: (function (param) {
                                                                Curry._1(setState, (function (__x) {
                                                                        return toggleResultChecked(__x, i);
                                                                      }));
                                                              })
                                                          })) : null, React.createElement("td", undefined, rndWrkSubs(res))))))
                              });
                  }), rndResultButtons(undefined));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, rndInput(undefined), rndResults(undefined)))
            });
}

var make = MM_cmp_substitution;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.clearResults = clearResults;
exports.setExpr1Str = setExpr1Str;
exports.setExpr2Str = setExpr2Str;
exports.swapExprs = swapExprs;
exports.copyExpr1ToExpr2 = copyExpr1ToExpr2;
exports.copyExpr2ToExpr1 = copyExpr2ToExpr1;
exports.toggleResultChecked = toggleResultChecked;
exports.rndIconButton = rndIconButton;
exports.findSubsByMatch = findSubsByMatch;
exports.findSubsByUnif = findSubsByUnif;
exports.make = make;
/* react Not a pure module */
